export enum TYPE {
    SOFTWARE= 'software',
    LINK= 'link',
    BUTTON= 'button',
    CLICK_ON_SOFTWARE_BUTTON= 'click_on_software_button',
    CLICK_ON_DOWNLOAD_BUTTON= 'click_on_download_button',
    CLICK_ON_SOFTWARE_LINK= 'click_on_software_link',
    CLICK_ON_DOWNLOAD_LINK= 'click_on_download_link'
}